import Model from "../Model";

class ComercialVisitsZone extends Model{

    buildUrl ({ param }) {
        return ['visitsbyzone/getbyzone', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new ComercialVisitsZone;